<template>
  <el-container>
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main class="page-main">
      <div class="content-header">
        <div class="content-header-back" >
          <i class="el-icon-arrow-left" @click="goBack()"></i>
          <span>完成随访人数</span>
        </div>
      </div>
      <div class="content-container">
        <div class="search-container">
          <div class="search-item">
            <label>姓名：</label>
            <el-input v-model="searchData.patientName" placeholder="输入姓名（模糊查找）"></el-input>
          </div>
          <div class="search-item">
            <label>住院号：</label>
            <el-input v-model="searchData.hospitalId" placeholder="住院号（精确查找）"></el-input>
          </div>
          <div class="search-item">
            <label>随访状态：</label>
            <el-cascader
                popper-class="special-popper-cascader"
                v-model="searchData.followupState"
                :options="followupStateOption"
                placeholder="请选择"
                clearable
                collapse-tags
                :show-all-levels="false"
                :props="{expandTrigger: 'hover',}"
              >
              </el-cascader>
          </div>
          <div class="search-item">
            <label>呼叫状态：</label>
            <el-select v-model="searchData.callState" placeholder="请选择">
              <el-option
                v-for="item in callStateOption"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <el-button type="primary" @click="searchHandle" size="small">查询</el-button>
            <el-button type="primary" @click="resetHandle" size="small">清空</el-button>
          </div>
        </div>
        <div class="content-taber">
          <div class="tab-container">
            <el-radio-group @change="searchHandle" v-model="timeInterval">
              <el-radio-button :label="1">当日</el-radio-button>
              <el-radio-button :label="3">3天</el-radio-button>
              <el-radio-button :label="7">7天</el-radio-button>
              <el-radio-button :label="30">30天</el-radio-button>
              <el-radio-button :label="60">60天</el-radio-button>
              <el-radio-button :label="90">90天</el-radio-button>
              <el-radio-button :label="120">120天</el-radio-button>
              <el-radio-button :label="150">150天</el-radio-button>
            </el-radio-group>
          </div>
          <div class="task-des-container">
            <div class="task-des-item">
              <div class="task-des">
                随访成功人数：
                <span v-text="`${statistics.success}`"></span>
              </div>
              <div class="task-des">
                未成功人数：
                <span v-text="`${statistics.refuse}`"></span>
              </div>
              <div class="task-des">
                失访人数：
                <span v-text="`${statistics.lost}`"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-container-title">
            <span>今日完成随访</span>
          </div>
          <div class="table-container-table">
            <el-table :border="true" :data="tableData" v-loading="loading" height="500">
              <el-table-column prop="name" label="姓名" align="center"></el-table-column>
              <el-table-column prop="sex" label="性别" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.sex | sexFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" align="center"></el-table-column>
              <el-table-column prop="admitNo" label="住院号" align="center"></el-table-column>
              <el-table-column prop="doctorName" label="主诊医生" align="center"></el-table-column>
              <el-table-column prop="treatmentMode" label="治疗方式" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.treatmentMode?scope.row.treatmentMode:"-"}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="followupState" label="随访状态" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.followupState | followupStateFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phoneNumber" label="最后呼叫" align="center"></el-table-column>
              <el-table-column prop="followUpCompleteTime" label="随访完成时间" align="center" width="180"></el-table-column>
              <el-table-column prop="callStateStr" label="呼叫状态" align="center" width="160">
              </el-table-column>
              <el-table-column prop="spotCheck" label="质控情况" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.spotCheck" v-text="`${scope.row.spotCheck}`"></span>
                  <span v-else>未质控</span>
                </template>
              </el-table-column>
              <el-table-column v-if="isRecordingSplit" prop="isSplitRecording" label="录音情况" align="center">
              </el-table-column>
              <el-table-column label="操作" prop="address" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="goDetail(scope.row)" >查看详情</el-button>
                  <!-- <span v-if="scope.row.spotCheck" style="color:#949090;">查看详情</span> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <p>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :page-count="totalPage"
              :current-page="currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </p>
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script type="text/ecmascript-6">
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { mapGetters } from "vuex";
import {
  RestNewFollowupCallCenterServiceGetFollowUpTodayComplete,
  RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount
} from "@src/assets/js/api.js";
import {MyMixin} from "@mixins/aliyunCallMixin"

import axios from "axios";
import qs from "qs";
import storage from "../../../assets/js/storage";
export default {
  name: "FollowupFinished",
  components: {
    Header,
    Footer
  },
  mixins: [MyMixin],
  data() {
    return {
      isRecordingSplit: false,
      timeInterval: 1,
      searchData: {
        patientName: "",
        hospitalId: "",
        followupState: "",
        callState: ""
      },
      tableData: [],
      loading: false,
      totalPage: 1,
      currentPage: 1,
      followupStateOption: [
        {label: '成功', value: '9'},
        {label: '旧数据（原拒随）', value: '11'},
        {
          label: '未成功', 
          children: [
            {label: '沟通不畅', value: '16'},
            {label: '拒绝随访（有信息）', value: '17'},
            {label: '拒绝随访（无信息）', value: '18'},

          ]
        },
        {label: '失访', value: '10'},
      ],
      // callStateOption: [
      //   { label: "电话随访成功", value: 4 },
      //   { label: "拒绝随访", value: 11 },
      //   { label: "沟通不畅", value: 15 },
      //   { label: "挂断（接通）", value: 6 },

      //   { label: "无人接听", value: 7 },
      //   { label: "不知情", value: 14 },
      //   { label: "关机", value: 10 },
      //   { label: "空号", value: 12 },
      //   { label: "停机", value: 9 },
      //   { label: "错号", value: 13 }
      // ],
      callStateOption: [
        {value: 1, label: '稍后拨打'},
        {value: 2, label: '仅随访该号码'},
        {value: 3, label: '短信随访成功'},
        {value: 4, label: '电话随访成功'},
        {value: 5, label: '初始化'},
        {value: 6, label: '挂断（接通）'},
        {value: 7, label: '无人接听'},
        {value: 8, label: '挂断（未接通）'},
        {value: 9, label: '停机'},
        {value: 10, label: '关机'},
        {value: 11, label: '拒随'},
        {value: 12, label: '空号'},
        {value: 13, label: '错号'},
        {value: 14, label: '不知情'},
        {value: 15, label: '沟通不畅'},
      ], // 电话状态列表
      statistics: {
        success: 0,
        lost: 0,
        refuse: 0
      }
    };
  },
  computed: {
    ...mapGetters(["userid", "getTaskCenterId"])
  },
  mounted() {
    this.getFollowUpTaskSwitchMark()
    this.getTableList();
    this.getFollowUpTodayCompleteCount();
  },
  filters: {
    sexFilter(value) {
      let result;
      switch (value * 1) {
        case 1:
          result = "男";
          break;
        case 2:
          result = "女";
          break;
      }
      return result;
    },
    followupStateFilter(state) {
      switch (state) {
        case 0:
          return '数据初始化'
          break
        case 1:
          return '短信随访待开始'
          break
        case 2:
          return '短信发送1次'
          break
        case 3:
          return '短信发送2次'
          break
        case 4:
          return '短信随访失败'
          break
        case 5:
          return '短信随访成功'
          break
        case 6:
          return '电话随访待开始'
          break
        case 7:
          return '电话随访进行中'
          break
        case 8:
          return '电话随访稍后拨打'
          break
        case 9:
          return '电话随访成功'
          break
        case 10:
          return '电话随访失访'
          break
        case 11:
          return '旧数据（原拒随）'
          break
        case 12:
          return '死亡'
          break
        case 13:
          return '异常号码'
          break
        case 16:
          return '沟通不畅'
          break
        case 17:
          return '拒绝随访（有信息）'
          break
        case 18:
          return '拒绝随访（无信息）'
          break
      }
    },
  },
  methods: {
    clearInter() {
      let vm = this;
      clearInterval(vm.timer);
      vm.createInter();
    },
    createInter() {
      let vm = this;
      this.timer = setInterval(() => {
        var str = "";
        for (var i = 0; i < 7; i += 1) {
          str += Math.floor(Math.random() * 10);
        }
        var Myhttp = axios.create({
          headers: {
            "Content-Type":
                "application/x-www-form-urlencoded;charset=utf-8;boundary =" +
                str,
            "jwt": storage.getStorage("jwt")
          },
        });
        let data = {
          request: {instanceId: `${aliyunConfig.aliyunInstance}`},
        };
        Myhttp.post(
            aliyunConfig.ajaxPath + "?action=RefreshToken",
            qs.stringify({
              request: JSON.stringify({
                instanceId: `${aliyunConfig.aliyunInstance}`,
              }),
            })
        )
            .then(function (res) {
              console.log("手动刷新success path:login/318==>", res);
            })
            .catch(function (err) {
              clearInterval(vm.timer);
              console.log("手动刷新error path:login/318===>", err);
            });
      }, 20 * 60 * 1000);
    },
    //阿里云灯登录 
    goBack() {
      this.$router.push({
          path: "/taskDetail",
          query: {
            diseaseId: this.$route.query.diseaseId,
          }
        });
    },
    getFollowUpTaskSwitchMark() {
      this.$store.dispatch('requestHandler',{
        fn: 'RestNewFollowupCallCenterServiceGetFollowUpTaskSwitchMark',
        params: {
          followUpTaskId: this.getTaskCenterId
        }
      }).then(res => {
        this.isRecordingSplit = res.retValue.isRecordingSplit
      })
    },
    searchHandle() {
      this.getTableList();
      this.getFollowUpTodayCompleteCount()
    },
    resetHandle() {
      this.searchData = {
        patientName: "",
        hospitalId: "",
        followupState: "",
        callState: ""
      };
      this.getTableList();
    },
    getTableList() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: this.currentPage,
        pageSize: 10
      };
      this.loading = true;
      this.getFollowUpTodayCompleteListAsync(params).then(res => {
        
        this.loading = false;
        this.tableData = res.retValue.map(item => {
          item.isSplitRecording = item.isSplitRecording ? '已分割' : '未分割'
          item.callStateStr = item.callState?this.callStateOption.find(it => it.value == item.callState).label:''
          return item
        });
        this.totalPage = res.totalPage;
        this.currentPage = res.page;
      });
    },
    currentChange(page) {
      this.currentPage = page;
      this.getTableList();
    },
    getFollowUpTodayCompleteCount() {
      this.getFollowUpTodayCompleteCountAsync().then(res => {
        this.statistics = {
          success: res.retValue.success,
          lost: res.retValue.lost,
          refuse: res.retValue.refuse
        };
      });
    },
    goDetail(params) {
      if(window.workbench) {
          this.$router.push({
            path: "/callPatient",
            query: {
              abnormal: 6, //今日随访完成的患者
              followUpPatientInfoId: params.followUpPatientInfoId,
              followupPatientId: params.followupPatientId,
              diseaseId: this.$route.query.diseaseId,
              followupState: params.followupState,
              followupSource: 2,
              isRecord: true
            }
          });
      }else {
        const loading = this.$loading({
          lock: true,
          text: '正在登录阿里云请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.initAliyunCall()
            .then((result) => {
              console.log('result',result);
              if(result) {
                this.$router.push({
                  path: "/callPatient",
                  query: {
                    abnormal: 6, //今日随访完成的患者
                    followUpPatientInfoId: params.followUpPatientInfoId,
                    followupPatientId: params.followupPatientId,
                    diseaseId: this.$route.query.diseaseId,
                    followupState: params.followupState,
                    followupSource: 2
                  }
                });
                this.clearInter();
                loading.close();
              }
            })
      }

    },
    // ===============================
    // 获取今日随访完成
    async getFollowUpTodayCompleteListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTodayComplete();
      request.p_followUpTaskId = p.followupTaskId;
      request.p_seatId = p.userId;
      request.p_patientName = this.searchData.patientName || null;
      request.p_hospitalId = this.searchData.hospitalId || null;
      request.p_followupState =  this.searchData.followupState?this.searchData.followupState.filter(str => str !== undefined)[0] : null;
      request.p_callState = this.searchData.callState || null;
      request.p_timeInterval = this.timeInterval || null
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    async getFollowUpTodayCompleteCountAsync() {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount();
      request.p_followUpTaskId = this.getTaskCenterId;
      request.p_timeInterval = this.timeInterval
      request.p_seatId = this.userid;
      await request.send();
      return request.result;
    }
  }
};
</script>
<style scoped lang="scss">
.page-main {
  height: calc(100vh - 60px - 60px);
  margin: 0px;
  padding: 0px;
  //overflow: auto;
}
.task-des-container {
  padding: 12px 0;
  margin-right: 20px;
  background-color: #cde9ff;
  border-radius: 5px;
  min-width: 460px;
  .task-des-item {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .task-des {
      margin: 0 18px;
    }
    .task-des-followup {
      cursor: pointer;
      border-bottom: 1px solid;
    }
    &:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
  }
}
.content-taber {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #ccc;
  &-back {
    display: flex;
    align-items: center;
    font-size: 18px;
    i {
      font-size: 24px;
      font-weight: bold;
      cursor: pointer;
      height: 60px;
      line-height: 60px;
      width: 50px;
      text-align: center;
    }
    i:hover {
      background: #e4e4e4;
    }
  }
}
.content-container {
  //padding: 30px 80px;
  height: calc(100vh - 60px - 60px - 62px);
  padding: 10px 20px 0 20px;
  .search-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .search-item {
      margin-right: 20px;
      margin-bottom: 10px;
      & > .el-input {
        width: auto;
      }
    }
  }
  .table-container {
    margin: 20px 0;
    &-title {
      height: 30px;
      line-height: 30px;
      border-left: 5px solid #248cfa;
      span {
        font-size: 16px;
        font-weight: bold;
        padding: 0 10px;
      }
    }
    &-table {
      margin: 20px 0;
    }
  }
}
</style>